import { DatePipe } from "@angular/common";
import { inject, Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'localDate', standalone: false })
export class LocalDatePipe implements PipeTransform {
    private dPipe = inject(DatePipe);

    transform(value?: number) {
        if (!value) {
            return null;
        }
        return this.dPipe.transform(new Date(value), 'M/d/yyyy');
    }
}

@Pipe({ name: 'localDateTime', standalone: false })
export class LocalDateTimePipe implements PipeTransform {
    private dPipe = inject(DatePipe);

    transform(value?: number) {
        if (!value) {
            return null;
        }
        return this.dPipe.transform(new Date(value), 'short');
    }
}

@Pipe({ name: 'prettyDate', standalone: false })
export class PrettyDatePipe implements PipeTransform {
    private dPipe = inject(DatePipe);

    transform(value?: number) {
        if (!value) {
            return null;
        }
        return this.dPipe.transform(new Date(value), 'longDate');
    }
}